import { createFileRoute, Outlet } from "@tanstack/react-router"
import { NavigationHeader } from "@/components/e2e/layout/NavigationHeader"
import { LlmGwSideNav } from "@/components/agents/monitoring/shared"
import { usePageHead } from "../../compat/head"

// Port of app/agent-queue/layout.tsx — the one layout with real shell chrome
// (global nav + the vertical side nav shared by all /agent-queue children).
export const Route = createFileRoute("/agent-queue")({ component: AgentQueueLayout })

function AgentQueueLayout() {
  usePageHead({ title: "Agent Runs" })
  return (
    <div className="flex h-screen flex-col overflow-hidden bg-background">
      <NavigationHeader currentPage="agent-queue" />
      <div className="flex min-h-0 flex-1">
        <>
          <LlmGwSideNav />
        </>
        <main className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
